/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_One_Time_Code_TitleInputs */

const en_delete_account_one_time_code_title = /** @type {(inputs: Delete_Account_One_Time_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-Time Code`)
};

const es_delete_account_one_time_code_title = /** @type {(inputs: Delete_Account_One_Time_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de un solo uso`)
};

const ar_delete_account_one_time_code_title = /** @type {(inputs: Delete_Account_One_Time_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رمز لمرة واحدة`)
};

/**
* | output |
* | --- |
* | "One-Time Code" |
*
* @param {Delete_Account_One_Time_Code_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_one_time_code_title = /** @type {((inputs?: Delete_Account_One_Time_Code_TitleInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_One_Time_Code_TitleInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_one_time_code_title(inputs)
	if (locale === "es") return es_delete_account_one_time_code_title(inputs)
	return ar_delete_account_one_time_code_title(inputs)
});